import { render } from "./EmployeeTimeReport.vue?vue&type=template&id=7c15c69e&scoped=true"
import script from "./EmployeeTimeReport.vue?vue&type=script&lang=js"
export * from "./EmployeeTimeReport.vue?vue&type=script&lang=js"

import "./time-reports.scss?vue&type=style&index=0&id=7c15c69e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c15c69e"]])

export default __exports__